export function getAssignedCount(game) {
  return (
    game.stats?.totalPlaytesters ??
    game.assignedCount ??
    game.assignedPlaytestersCount ??
    game.assignedPlaytesters?.length ??
    0
  );
}

export function computeDeveloperStats(dashboardData, games) {
  const overview = dashboardData?.overview || dashboardData?.stats || {};
  const computedActiveGames = games.filter((g) => getAssignedCount(g) > 0).length;

  return {
    totalGames: games.length || overview.totalGames || 0,
    activeGames: overview.activeGames ?? computedActiveGames,
    completedGames:
      overview.completedGames ??
      games.filter((g) => g.status === "completed").length,
    totalPlaytesters:
      overview.totalPlaytesters ??
      games.reduce((sum, g) => sum + getAssignedCount(g), 0),
    totalFeedback: overview.totalFeedback ?? 0,
    averageRating: overview.averageRating ?? 0,
    totalSessions: overview.totalSessions ?? 0,
  };
}

export function buildActivityChartData(games, days = 14) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const labels = [];
  const playtesterCounts = [];
  const gameCounts = [];

  for (let i = days - 1; i >= 0; i -= 1) {
    const date = new Date(today);
    date.setDate(date.getDate() - i);
    const key = date.toISOString().slice(0, 10);

    labels.push(
      date.toLocaleDateString(undefined, { month: "short", day: "numeric" })
    );

    let dayPlaytesters = 0;
    let dayGames = 0;

    games.forEach((game) => {
      if (!game.createdAt) return;
      const created = new Date(game.createdAt);
      created.setHours(0, 0, 0, 0);
      if (created.toISOString().slice(0, 10) === key) {
        dayGames += 1;
        dayPlaytesters += getAssignedCount(game);
      }
    });

    gameCounts.push(dayGames);
    playtesterCounts.push(dayPlaytesters);
  }

  return { labels, playtesterCounts, gameCounts };
}

export function formatGameCreated(dateValue) {
  if (!dateValue) return "—";
  const date = new Date(dateValue);
  if (Number.isNaN(date.getTime())) return "—";
  return date
    .toLocaleString(undefined, {
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    })
    .toLowerCase();
}

export function getPlaytestResultMeta(game) {
  if (game?.playtestType === "free_public" || game?.isPublicPlaytest) {
    return { label: "Public · opt-in", variant: "pass" };
  }

  const assigned = getAssignedCount(game);
  const requested = game.numPlaytesters || 0;

  if (requested === 0 && assigned === 0) {
    return { label: "—", variant: "none" };
  }

  if (assigned >= requested && requested > 0) {
    return { label: `${assigned} / ${requested} assigned`, variant: "pass" };
  }

  if (assigned > 0) {
    return { label: `${assigned} / ${requested} assigned`, variant: "warn" };
  }

  return { label: `0 / ${requested} assigned`, variant: "warn" };
}
